const API_KEY = "AIzaSyC2J29WXRT3U3EO-Vu2doMogcX0pOv4RV8";

export default API_KEY;